export interface CustomerInfo {
  customerName: string;
  companyName: string;
  email: string;
  phone: string;
  country: string;
}

export interface ProductInfo {
  productName: string;
  description: string;
}

export interface MaterialInfo {
  material: string;
  finish: string;
  color: string;
}

export interface DimensionInfo {
  height: string;
  width: string;
  depth: string;
  weight: string;
}

export interface BuilderState {
  currentStep: number;
  customer: CustomerInfo;
  product: ProductInfo;
  material: MaterialInfo;
  dimensions: DimensionInfo;
  referenceImage: string | null;
  referenceImageName: string | null;
  generatedImages: string[];
  selectedImageIndex: number;
  isGenerating: boolean;
  isSubmitting: boolean;
  isSuccess: boolean;

  setCurrentStep: (step: number) => void;
  setCustomer: (data: Partial<CustomerInfo>) => void;
  setProduct: (data: Partial<ProductInfo>) => void;
  setMaterial: (data: Partial<MaterialInfo>) => void;
  setDimensions: (data: Partial<DimensionInfo>) => void;
  setReferenceImage: (image: string | null, name: string | null) => void;
  setGeneratedImages: (images: string[]) => void;
  setSelectedImageIndex: (index: number) => void;
  setIsGenerating: (val: boolean) => void;
  setIsSubmitting: (val: boolean) => void;
  setIsSuccess: (val: boolean) => void;
  resetBuilder: () => void;
}

export const MATERIALS = [
  'Brass',
  'Copper',
  'Wood',
  'Iron',
  'Steel',
  'Marble',
  'Ceramic',
  'Glass',
] as const;

export const FINISHES = [
  'Matte',
  'Polished',
  'Antique',
  'Gold',
  'Silver',
  'Chrome',
  'Brushed',
] as const;

export const COUNTRIES = [
  'United States',
  'United Kingdom',
  'Germany',
  'France',
  'Italy',
  'Spain',
  'Netherlands',
  'Belgium',
  'Switzerland',
  'Austria',
  'Sweden',
  'Norway',
  'Denmark',
  'Finland',
  'Canada',
  'Australia',
  'Japan',
  'South Korea',
  'China',
  'India',
  'UAE',
  'Saudi Arabia',
  'Qatar',
  'Kuwait',
  'Singapore',
  'Malaysia',
  'Brazil',
  'Mexico',
  'South Africa',
  'Other',
] as const;
